export { };

declare global {
    interface String {
        toNumber(): number;
        removeNonAlphaNumeric(): string;
        normalizeGuid(): string;
    }
}

// eslint-disable-next-line no-extend-native
String.prototype.toNumber = function (this: string) { return parseFloat(this) };

// eslint-disable-next-line no-extend-native
String.prototype.removeNonAlphaNumeric = function (this: string) { return this.replace(/\W/g, "") }

// eslint-disable-next-line no-extend-native
String.prototype.normalizeGuid = function (this: string): string { return this.replace(/[^a-zA-Z0-9]/g, '').toUpperCase(); }